const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  // Custom: Product Recommendations
  // Additional event to update production 
  cartRecommendations: 'cart-recommendations',
  // Custom: Delivery Price
  deliveryPriceLoaded: 'delivery-price-loaded',
};